export function formatFullName(firstName, middleInitial, lastName) {
    return [firstName, middleInitial, lastName].filter((n) => !!n).join(" ");
}
